import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { getData } from "./data"
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from "moment"
import TableLoader from "components/Common/TableLoader"

function Table(props) {
  const { data } = props
  const columns = [
    {
      dataField: "day",
      text: "Day Of Month",
      sort: true,
    },
    // {
    //   dataField: "Currency",
    //   text: "Currency",
    //   sort: true,
    // },
    {
      dataField: "uniq_player",
      text: "Unique Players",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.uniq_player).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "total_player",
      text: "Total Players",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.total_player).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "bonus_amount",
      text: "Total Bonus",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.bonus_amount).toLocaleString("en-GB")}</>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: data.length,
    totalSize: data.length,
    custom: true,
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Acca7 Report"}</div>
          {props.loadingMessage && props.loadingMessage == "1" ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="6">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div>
                                <ReactHTMLTableToExcel
                                  id="test-table-xls-button"
                                  className="download-table-xls-button w-md btn btn-primary"
                                  table="table-to-xls"
                                  filename={`Acca7-Report-${moment(
                                    new Date()
                                  ).format("DD/MM/YYYY")}`}
                                  sheet="tablexls"
                                  buttonText="Download"
                                  type="button"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm={6}></Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              id="table-to-xls"
                              keyField="id"
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              classes={
                                "table align-middle table-nowrap table-check"
                              }
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
    </>
  )
}

export default Table
